import { render, staticRenderFns } from "./GameControls.vue?vue&type=template&id=12f92a0c"
import script from "./GameControls.vue?vue&type=script&lang=js"
export * from "./GameControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.100.1__lodash@4.17.21_webpack@5.100.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports